import { createLocalExpirableStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';
import type {
	ExpirableWebStorageProvider,
	ExpirableWebStorageProviderNew,
} from '@jira/platform__browser-storage-providers/src/types.tsx';

// eslint-disable-next-line jira/web-storage/no-export-browser-storage-provider
export const localStorageProvider: ExpirableWebStorageProvider | ExpirableWebStorageProviderNew =
	createLocalExpirableStorageProvider('onboarding-core');
